export class GridColumn {
    constructor(obj: { dataField: string, header?: string, subDataField?:string, strikeDataField?:string, subHeader?:string, disabled?:boolean, sticky?:boolean }) {
        this.dataField = obj.dataField;
        this.header = obj.header;
        this.subHeader = obj.subHeader;
        this.subDataField = obj.subDataField;
        this.strikeDataField = obj.strikeDataField;
        this.disabled = obj.disabled;
        this.sticky = obj.sticky;
    }

    dataField: string;
    header: string;
    subHeader: string;
    subDataField: string;
    strikeDataField: string;
    disabled: boolean;
    sticky: boolean;
}